var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6705_12494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.332 3.33989C18.8403 4.21075 20.095 5.46042 20.9718 6.96519C21.8487 8.46997 22.3174 10.1777 22.3315 11.9192C22.3455 13.6608 21.9045 15.3758 21.0521 16.8946C20.1996 18.4133 18.9653 19.6831 17.4713 20.5782C15.9773 21.4733 14.2754 21.9627 12.5341 21.998C10.7929 22.0332 9.07258 21.6131 7.54359 20.7791C6.01459 19.9452 4.7299 18.7264 3.8167 17.2434C2.90349 15.7604 2.39344 14.0646 2.33703 12.3239L2.33203 11.9999L2.33703 11.6759C2.39303 9.94888 2.89558 8.26585 3.79567 6.79089C4.69576 5.31592 5.96269 4.09934 7.47292 3.25977C8.98316 2.42021 10.6852 1.98629 12.413 2.00033C14.1409 2.01437 15.8356 2.47589 17.332 3.33989ZM16.039 9.29289C15.8668 9.12072 15.6377 9.01729 15.3947 9.002C15.1517 8.98672 14.9114 9.06064 14.719 9.20989L14.625 9.29289L11.332 12.5849L10.039 11.2929L9.94503 11.2099C9.75262 11.0607 9.5124 10.9869 9.26944 11.0022C9.02647 11.0176 8.79744 11.121 8.62529 11.2932C8.45315 11.4653 8.34971 11.6943 8.33438 11.9373C8.31906 12.1803 8.39289 12.4205 8.54203 12.6129L8.62503 12.7069L10.625 14.7069L10.719 14.7899C10.8944 14.926 11.1101 14.9998 11.332 14.9998C11.554 14.9998 11.7697 14.926 11.945 14.7899L12.039 14.7069L16.039 10.7069L16.122 10.6129C16.2713 10.4205 16.3452 10.1802 16.3299 9.93721C16.3146 9.69419 16.2112 9.46509 16.039 9.29289Z",
    fill: "#F48C06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6705_12494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.5a430533123f65a5742c00e9d35b587e.svg";
export { ForwardRef as ReactComponent };